export const SME_STAGING_HOST = 'sme.staging.ascsurvey.com'

export function isSmeStagingHost(hostname = globalThis.location?.hostname ?? ''): boolean {
  return hostname === SME_STAGING_HOST
}

export function canShowAnes008MediaProof(hostname = globalThis.location?.hostname ?? ''): boolean {
  return !isSmeStagingHost(hostname)
}
